import { useState } from 'react';
export function useOnce(value) {
    const [val] = useState(value);
    return val;
}
export function useBuildOnce(build) {
    const [val] = useState(build);
    return val;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlT25jZS5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJ1c2VPbmNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxPQUFPLENBQUE7QUFFaEMsTUFBTSxVQUFVLE9BQU8sQ0FBSSxLQUFRO0lBQ2xDLE1BQU0sQ0FBQyxHQUFHLENBQUMsR0FBRyxRQUFRLENBQUksS0FBSyxDQUFDLENBQUE7SUFDaEMsT0FBTyxHQUFHLENBQUE7QUFDWCxDQUFDO0FBRUQsTUFBTSxVQUFVLFlBQVksQ0FBSSxLQUFjO0lBQzdDLE1BQU0sQ0FBQyxHQUFHLENBQUMsR0FBRyxRQUFRLENBQUksS0FBSyxDQUFDLENBQUE7SUFDaEMsT0FBTyxHQUFHLENBQUE7QUFDWCxDQUFDIn0=